import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MailIcon from '@material-ui/icons/Mail';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input';
import Badge from '@material-ui/core/Badge';
import { Link as RouterLink } from 'react-router-dom';

import { makeStyles, useTheme } from '@material-ui/core/styles';

import AppSideNavBar from './AppSideNavBar';
import AppNavBar from './AppNavBar';

const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    
  },content: {
    marginTop: theme.spacing(9), 
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`
    },
    [theme.breakpoints.down('md')]: {
      width: `calc(100%)`
    },
    borderRadius: 0,
    border: 0,
    boxShadow: '0 0px 0px 0px rgba(0, 0, 0, 0)',
    background:'transparent',
    // background: 'yellow'
  },
}));

function ResponsiveDrawer(props) {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    console.log("asfasdf");
    setMobileOpen(!mobileOpen);
  };
  const classes = useStyles();
  
  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppNavBar  handleDrawerToggle={() => handleDrawerToggle()} ></AppNavBar>
      <AppSideNavBar mobileOpen={mobileOpen} handleDrawerToggle={() => handleDrawerToggle()} ></AppSideNavBar>
      <main className={classes.content}>
        {props.children}
      </main>
    </div>
  );
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default ResponsiveDrawer;
